import { render, staticRenderFns } from "./agentForm2.vue?vue&type=template&id=0fce52c3&scoped=true&"
import script from "./agentForm2.vue?vue&type=script&lang=js&"
export * from "./agentForm2.vue?vue&type=script&lang=js&"
import style0 from "./agentForm2.vue?vue&type=style&index=0&id=0fce52c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce52c3",
  null
  
)

export default component.exports